import { brand } from "../brand";
import { BETA_NOTICE, TERMS_VERSION } from "./legal";

export function Privacy() {
  return (
    <main className="narrow prose legal">
      <p className="muted">{BETA_NOTICE}</p>
      <h1>Privacy</h1>
      <section className="legal__plain" aria-label="In short">
        <h2>In short, if you are a student</h2>
        <ul>
          <li>
            We keep your email so you can sign in, and your book so we can make your material.
          </li>
          <li>Nobody else sees your book or your material. Not other students, not your school.</li>
          <li>We do not show adverts and we do not track you around the web.</li>
          <li>We keep a note of how much material was made, because making it costs money.</li>
          <li>If you want it all deleted, write to us and it is gone within a day.</li>
        </ul>
      </section>
      <h2>What we store, and why</h2>
      <table>
        <tbody>
          <tr>
            <th>Your email address</th>
            <td>To sign you in and to reply to you. For as long as your account exists.</td>
          </tr>
          <tr>
            <th>The files you upload</th>
            <td>
              To make your material, and to remake it if you change the chapter list. For as long as
              the book exists in your account; deleted when you delete it.
            </td>
          </tr>
          <tr>
            <th>The material made from them</th>
            <td>
              Flashcards, coverage findings, the exam format, papers and mark schemes. Yours to
              study; deleted with the book or the account.
            </td>
          </tr>
          <tr>
            <th>A record of what was made and what it cost</th>
            <td>
              Pages processed, papers written, the model used and its price, per account. To size
              allowances honestly. Kept with the account.
            </td>
          </tr>
          <tr>
            <th>Feedback you send</th>
            <td>
              What you typed, and which paper or deck it was about. Read by a person. Deleted with
              the account.
            </td>
          </tr>
          <tr>
            <th>An access log</th>
            <td>
              Each request to our service: the time, the path, which account it belonged to, and the
              IP address it came from. To find faults, and to see whether people come back. Kept for
              90 days, then discarded automatically.
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Where it is</h2>
      <p>
        Our service runs in Amazon Web Services&rsquo; London region and stores its database with
        Neon in the EU. To read a scanned page or write a paper, text and page images from your book
        are sent to a model provider through OpenRouter, which routes the call to whichever provider
        serves that model; where it runs is that provider&rsquo;s, and may be outside the EU. We do
        not train anything on your material, and we do not give it to anyone else for that purpose.
      </p>
      <h2>Who sees it</h2>
      <p>
        You. The operator, when you ask for help or when a fault has to be traced. Nobody else: no
        advertising, no analytics service, no third-party tracking of any kind.
      </p>
      <h2>Your rights</h2>
      <p>
        You can ask what we hold, have it corrected, or have it all deleted, by writing to{" "}
        {brand.supportEmail}. You are 13 or older to use {brand.name}; we do not knowingly hold an
        account for anyone younger.
      </p>
      <h2>Who is responsible</h2>
      <p>
        […] — the controller&rsquo;s name and address; to be completed before general availability.
      </p>
      <p className="muted">Version {TERMS_VERSION}.</p>
    </main>
  );
}
